import Image from 'next/image';
import { useState } from 'react';
import { Group, Menu, UnstyledButton } from '@mantine/core';
import { IconChevronDown } from '@tabler/icons-react';
import { switchLocaleAction } from '@/actions/switch-locale';
import { useTranslation } from '@/i18n/client';
import classes from './LanguagePicker.module.css';

export function LanguagePicker() {
  const [opened, setOpened] = useState(false);
  const { i18n } = useTranslation('translation');

  const lang = i18n.language;
  const handleLocaleChange = async (lang: 'ru' | 'en') => {
    await switchLocaleAction(lang);
  };

  return (
    <Menu
      onOpen={() => setOpened(true)}
      onClose={() => setOpened(false)}
      radius='md'
      width='target'
      withinPortal
      trigger='hover'
    >
      <Menu.Target>
        <UnstyledButton className={classes.control} data-expanded={opened || undefined}>
          <Group gap='xs'>
            <Image
              src={`/static/images/lang/${lang}.png`}
              width={22}
              height={22}
              alt={lang.toUpperCase()}
            />
            <span className={classes.label}>{lang.toUpperCase()}</span>
          </Group>
          <IconChevronDown size={16} className={classes.icon} stroke={1.5} />
        </UnstyledButton>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          leftSection={<Image src='/static/images/lang/en.png' width={18} height={18} alt='EN' />}
          onClick={() => {
            handleLocaleChange('en');
          }}
        >
          EN
        </Menu.Item>
        <Menu.Item
          leftSection={<Image src='/static/images/lang/ru.png' width={18} height={18} alt='RU' />}
          onClick={() => {
            handleLocaleChange('ru');
          }}
        >
          RU
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

export default LanguagePicker;
